<template>
  <div>
    <RideCopyOffer :ride="ride"/>
    <b-container class="pt-5">
      <div class="single_ride_sumary">
        <main>
          <section>
            <RideDates :ride="ride"/>
            <PresentUserInfo/>
            <RideMedia :ride="ride"/>
            <div class="trip-date-section">
              <div class="container">
                <RideDescription :ride="ride"/>
                <ClassicTimeline v-if="summaryAvailable"/>
                <RideGeneralInfo :ride="ride"/>
              </div>
            </div>
          </section>
        </main>
      </div>
    </b-container>
  </div>
</template>

<script>
import PresentUserInfo from "@/components/PresentUserInfo";
import RideCopyOffer from "@/components/RideSummary/RideCopyOffer";
import RideDates from "@/components/RideSummary/RideDates";
import RideMedia from "@/components/RideSummary/RideMedia";
import RideDescription from "@/components/RideSummary/RideDescription";
import RideGeneralInfo from "@/components/RideSummary/RideGeneralInfo";
import ClassicTimeline from "./ClassicTimeline";

/**
 * The classic trip page: dates, description, then the activities /
 * accommodations summary, whose map button swaps the list for the map.
 *
 * A design layout -- see src/designs/index.js for the contract every layout
 * keeps (props, and the .single_ride_sumary element).
 */
export default {
  name: 'ClassicLayout',
  components: {
    PresentUserInfo,
    RideCopyOffer,
    RideDates,
    RideMedia,
    RideDescription,
    RideGeneralInfo,
    ClassicTimeline,
  },
  props: {
    ride: { type: Object, required: true },
    days: { type: Array, default: () => [] },
    summaryAvailable: { type: Boolean, default: false },
  },
};
</script>
